import { useState, useEffect } from 'react';

const STORAGE_KEY = 'portfolio-theme';
const MODES = ['dark', 'light', 'system'];

export const useTheme = () => {
  const [mode, setMode] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'system'; } catch { return 'system'; }
  });

  useEffect(() => {
    const root = document.documentElement;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = () => {
      const effective = mode === 'system' ? (mq.matches ? 'dark' : 'light') : mode;
      root.setAttribute('data-theme', effective);
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.content = effective === 'dark' ? '#0b0b0b' : '#faf8f4';
    };

    apply();
    try { localStorage.setItem(STORAGE_KEY, mode); } catch {}

    if (mode === 'system') {
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [mode]);

  const cycle = () => setMode(m => MODES[(MODES.indexOf(m) + 1) % MODES.length]);

  return { mode, cycle };
};
